import React, { useState, useEffect, useContext } from 'react';
import { Stage, Layer, Image } from 'react-konva';
import useImage from 'use-image';
import HyCAP from '../../../assets/HyCAP.svg';
import Clamp from '../../../assets/Clamp.svg';
import InjectionUnit from '../../../assets/InjectionUnit.svg';
import { MachineCanvasProps } from '../../../../InjectionCycle/components/interfaces';
import { KonvaEventObject } from 'konva/lib/Node';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../../../../../App';

const HyCAPCanvas: React.FC<MachineCanvasProps> = ({ hoveredPart, setHoveredPart, machineName, navigationState }) => {
    const navigate = useNavigate();
    const appContextProps: any = useContext(AppContext)
    const [stageSize, setStageSize] = useState({ width: window.innerWidth, height: 550 });

    const [HyCAPImg] = useImage(HyCAP);
    const [ClampImg] = useImage(Clamp);
    const [InjectionUnitImg] = useImage(InjectionUnit);

    const handleMouseMove = (e: KonvaEventObject<MouseEvent>) => {
        const { x, y } = e.target.getStage()?.getPointerPosition() || { x: 0, y: 0 };
        
        if (x >= stageSize.width * 0.1927 && x <= stageSize.width * 0.42 && y >= stageSize.height * 0.235 && y <= stageSize.height * 0.68 && navigationState[("Clamp Unit").toLowerCase()] ) {
            setHoveredPart('Clamp Unit');
        } else if ((x >= stageSize.width * 0.445 && x <= stageSize.width * 0.53 && y >= stageSize.height * 0.45 && y <= stageSize.height * 0.53 ) || (x >= stageSize.width * 0.53 && x <= stageSize.width * 0.655 && y >= stageSize.height * 0.4 && y <= stageSize.height * 0.56) || (x >= stageSize.width * 0.51 && x <= stageSize.width * 0.56 && y >= stageSize.height * 0.1 && y <= stageSize.height * 0.53) && navigationState[("Injection Unit").toLowerCase()] ) {
            setHoveredPart('Injection Unit');
        } else {
            setHoveredPart('');
        }
    };

   useEffect(() => {
       const handleResize = () => {
         setStageSize({
           width: window.innerWidth - (appContextProps.sideBarOpenStatus ? 260 : 10),
           height: 550,
         });
       };
    handleResize(); // Call handleResize immediately to set the initial size
       window.addEventListener('resize', handleResize);
       return () => window.removeEventListener('resize', handleResize);
     }, [appContextProps.sideBarOpenStatus]);

    return (
        <Stage width={stageSize.width} height={stageSize.height} onMouseMove={handleMouseMove}>
            <Layer>
                <Image
                    image={HyCAPImg}
                    x={stageSize.width * 0.08}
                    y={stageSize.height * 0.12}
                    width={stageSize.width * 0.70}
                    height={stageSize.height * 0.75}
                />
                {hoveredPart === 'Clamp Unit' && (
                    <Image
                        image={ClampImg}
                        x={stageSize.width * 0.1927}
                        y={stageSize.height * 0.235}
                        width={stageSize.width * 0.2273}
                        height={stageSize.height * 0.516}
                        onClick={()=> navigate(`/usecase/injection-pdm/hycaps/${machineName}/Clamp%20Unit/machineview`,{ state: navigationState[('Clamp Unit').toLowerCase()] })}
                    />
                )}
                {hoveredPart === 'Injection Unit' && (
                    <Image
                        image={InjectionUnitImg}
                        x={stageSize.width * 0.445}
                        y={stageSize.height * 0.11}
                        width={stageSize.width * 0.213}
                        height={stageSize.height * 0.53}
                        onClick={()=> navigate(`/usecase/injection-pdm/hycaps/${machineName}/Injection%20Unit/machineview`, { state: navigationState[('Injection Unit').toLowerCase()] })}
                    />
                )}
            </Layer>
        </Stage>
    )
}

export default HyCAPCanvas;
